@for (button of buttons(); track $index) {
    <ion-button (click)="button.clicked()" [innerHTML]="button.title" [ngClass]="button.class"></ion-button>
}
